<template>
    <footer>
        <div class="about">
            <div class="inner">
                <div class="about_us">
                    <ul>
                        <li class="title">联系我们</li>
                        <li>联系电话:  {{company.companyPhone||'暂无联系电话'}}</li>
                        <li>电子邮箱:  {{company.companyEmail||'暂无电子邮箱'}}</li>
                        <li>机构地址:  {{company.companyAddress||'机构地址'}}</li>
                    </ul>
                    <div class="code_box">
                        <div class="code_left">
                            <img src="~@/assets/images/erweima.png" alt="扫码下载Android端APP">
                            <div class="code_txt">扫码下载Android端APP</div>
                        </div>
                        <div class="code_right">
                            <img src="~@/assets/images/ios.png" alt="扫码下载iOS端APP">
                            <div class="code_txt">扫码下载iOS端APP</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="bottom">
            <div class="inner">
                <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44011102001912" target="_band">
                    <div>河南杰文信息科技有限公司</div>
                <div class="left">ICP豫公网备案 1321313212313132 号</div>
                </a>
                <!--  -->
            </div>
        </div>
    </footer>
</template>
<script>
import { getCompany } from '@/api/user'
export default {
    data(){
        return {
            company:{}
        }
    },
    created(){
        getCompany().then(res=>{
            this.company = res.data
        })
    }
}
</script>
<style lang="scss" scoped>
.about{
    background: #3964E6;
    color: #fff;
    .about_us{
        display: flex;
        justify-content: space-between;
        padding-top: 58px;
        padding-bottom: 21px;
        ul{
            padding-top: 35px;
            li{
                font-size: 20px;
                font-weight: bold;
                color: #FFFFFF;
                line-height: 1;
                margin-bottom: 21px;
            }
            .title{
                font-size: 40px;
                font-weight: bold;
                color: #FFFFFF;
                line-height: 1;
                margin-bottom: 29px;
            }
        }
    }
    .code_box{
        display: flex;
        text-align: center;
        .code_right{
            margin-left: 50px;
        }
        .code_txt{
            margin-top: 19px;
        }
    }
}
.bottom{
    background: #000;
    color: #999999;
    padding: 10px 0px;
    .inner{
        a{
            display: flex;
            justify-content: center;
        }
        .left{
            margin-left: 248px;
        }
        div{
            cursor: pointer;
        }
    }
}
</style>